// extracted by mini-css-extract-plugin
module.exports = {"resultCard":"styles__resultCard___16kvg","supplierCard":"styles__supplierCard___jEd-J","name":"styles__name___1HL3i","companyLink":"styles__companyLink___3SN5F"};